import { getCustomerTypes } from "../../helpers/fetching";

export default {
  state: {
    types: [],
    loading: false,
    error: null,
    response: {},
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setResponse(state, data) {
      state.response = data;
    },
    setCustomerTypes(state, data) {
      state.types = data;
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    fetchCustomerTypes({ commit }, value) {
      return new Promise((resolve) => {
        console.log(value);
        commit("clearError");
        commit("setLoading", true);
        getCustomerTypes(value)
          .then((response) => {
            commit("setCustomerTypes", response);
            commit("setLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setError", error);
            resolve();
          });
      });
    },
  },
};
